import { Card, Modal } from 'antd';

const headingColor = '#1677ff';

export const QuickStartModal = ({ open, onClose }) => (
  <Modal
    width="80%"
    title={<span style={{ color: headingColor }}>Quick Start</span>}
    footer={null}
    open={open}
    onCancel={onClose}
  >
    <Card className="mt-16" size="small">
      1. Set your Goals by clicking the Goals button on the Dashboard.
      <br />
      <br />
      2. Click the Production Button on the Dashboard.
      <br />
      <br />
      3. Choose a Category from the “Category” column: This time choose Agricultural Products.
      <br />
      <br />
      4. Choose a Product from the “Product” column that appears: This time choose Lumber.
      <br />
      <br />
      5. Choose a Process to actually make the lumber. This time choose the Forest Land and Unskilled Labor icons as
      your inputs. The Factors box will turn green indicating you have enough of both inputs to make the product.
      <br />
      <br />
      6. Look at the Lumber page. Across the top left, you will see your country’s current amount of lumber and its GDP
      value per unit, and at the top right you’ll see how many units and pollution this production will make.
      <br />
      <br />
      7. Note how Lumber is made and why Lumber is useful.
      <br />
      <br />
      8. Enter a number for each input so that their multiplied value meets or exceeds the Factor value: 10 times 1, 1
      times 10, 5 times 2, or 2 times 5. The Input box will turn green indicating you are successfully making that
      product.
      <br />
      <br />
      9. Scroll to the bottom of the page and enter 1 where it asks “Repeat Procedure?”.
      <br />
      <br />
      10. Click the Produce Button and then the Confirm Button.
      <br />
      <br />
      11. Scroll to the top of the page and notice you have gained 100 units of Lumber.
      <br />
      <br />
      12. Repeat steps above for a different Category-Product-Process.
      <br />
      <br />
      <b>Explore!</b>
      <br />
      <br />
      Need to start over (for any reason)?
      <br />
      Click the “Feed the People” button on the dashboard, but be sure not to actually feed anyone anything even if you
      have enough food. Continue clicking the various buttons until you get to the box that says “All your population
      has died!”. Click the “Reset Resources” button and follow the appropriate buttons to start the new year.
    </Card>
  </Modal>
);
